/**
 * Format a numeric amount as a locale-aware currency string.
 *
 * @param {number|string|null|undefined} amount
 * @param {object} [options]
 * @param {string} [options.currencyCode='USD'] - ISO 4217 code (USD, GBP, AUD...)
 * @param {string} [options.locale='en-US'] - BCP 47 language tag
 * @param {boolean} [options.trimZeros=false] - When true, drop fraction digits
 *   for whole-number amounts. Fractional amounts keep their digits.
 * @returns {string}
 */
function formatCurrency(amount, { currencyCode = 'USD', locale = 'en-US', trimZeros = false } = {}) {
  const numericValue = amount === null || amount === undefined || amount === ''
    ? 0
    : Number(amount);

  const value = Number.isFinite(numericValue) ? numericValue : 0;

  const isWholeNumber = value % 1 === 0;
  const fractionDigits = trimZeros && isWholeNumber ? 0 : 2;

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  });

  return formatter.format(value);
}



export default formatCurrency;
